/**
 * All features ported from `@scoro/constants` PHP package `Feature.php`.
 * Please keep these files synced if making changes.
 */
export const Feature = {
	ACCOUNTING_OBJECTS: 'accounting_objects',
	ACTIVITY_BASED_BILLING: 'activityBasedBilling',
	ACTIVITY_LOCKING: 'activityLocking',
	ADDITIONAL_EMAIL_SENDER_ALIASES: 'additionalEmailSenderAliases',
	ADVANCED_REPORTING: 'advancedReporting',
	AI_COACH: 'aiCoach',
	API: 'API',
	API_V3: 'APIv3',
	AXAPTA: 'axapta',
	BILLABLE_HOURS: 'billable_hours',
	BONUS_CALCULATOR: 'bonusCalculator',
	BOOKINGS: 'bookings',
	BOOKING_GRAPH: 'bookingGraph',
	BOOKMARKS_CUSTOMIZABLE: 'bookmarksCustomizable',
	CALENDAR_INVITES: 'calendarInvites',
	CALENDAR_RESOURCE_MANAGEMENT: 'calendar_resource_management',
	CHANGE_TASK_OWNER: 'change_task_owner',
	CLIENT_PROFILES: 'clientProfiles',
	COMMENTS: 'comments',
	COMPARATIVE_REPORTS: 'comparativeReports',
	CONFIRM_EVENTS: 'confirm_events',
	CREATE_FIELDS: 'create_fields',
	CREATE_TEMPLATES: 'create_templates',
	CREDIT_MANAGEMENT: 'creditManagement',
	CUSTOMER_SERVICE: 'customerService',
	CUSTOMIZATION: 'customization',
	CUSTOM_FIELDS: 'create_fields',
	CUSTOM_MODULES: 'custom_modules',
	CUSTOM_VIEWS_AND_STATUSES: 'custom_views_and_statuses',
	DASHBOARD_METRICS: 'dashboardMetrics',
	DASHLETS_LIBRARY: 'dashlets_library',
	DATABASE_DUMP: 'databaseDump',
	DATES_ON_INVOICE_LINES: 'datesOnInvoiceLines',
	DEPOT: 'depot',
	DETAILED_FINANCIAL_REPORTS: 'detailedFinancialReports',
	DETAILED_WORK_REPORTS: 'detailedWorkReports',
	DIRECTO: 'directo',
	DISABLE_REFERRALS: 'disableReferrals',
	DROPBOX: 'dropbox',
	EARVEKESKUS_SYNC: 'earvekeskus_sync',
	ELI_GENERAL_CHAT: 'eli_general_chat',
	ELI_BRAIN_CYCLES: 'eli_brain_cycles',
	ELION_CSV: 'elion_csv',
	ELION_SMART_CALLS: 'elionSmartCalls',
	EXCHANGE_SYNC: 'exchangeSync',
	EXPENSIFY_SYNC: 'expensify_sync',
	FINES: 'fines',
	FOOLS_BUGS: 'foolsBugs',
	FOOLS_CLIPPY: 'foolsClippy',
	FOOLS_DIRECTO_SKIN: 'directoSkin',
	FOOLS_ELEVATOR: 'foolsElevator',
	FOOLS_SEND_EMAIL_BUTTON_FLY: 'sendEmailButtonFly',
	FORCE_NEW_PRODUCT_FILTER: 'newProductFilter',
	FTP: 'ftp',
	GOOGLE_DRIVE: 'googleDocs',
	HANSARAAMA: 'hansaraama',
	INTEGRATIONS: 'integrations',
	INTRA: 'intra',
	HIGH_LEVEL_RESOURCE_PLANNING: 'high_level_resource_planning',
	KICKBACK: 'kicker',
	KREDIIDIINFO: 'krediidiinfo',
	LABOR_COST: 'laborCost',
	LABOR_COST_ROLE_BASED: 'laborCostRoleBased',
	LATVIAN_CREDIT_REGISTRY: 'latvianCreditRegistry',
	LITHUANIAN_CREDIT_REGISTRY: 'lithuanianCreditRegistry',
	MAILCHIMP: 'mailchimp',
	MARGIN: 'margin',
	MEDIA_ADDONS: 'media_addons',
	MEDIA_PLAN: 'mediaPlan',
	MEELDETULETUSKESKUS: 'meeldetuletuskeskus',
	METRIC_HISTOGRAM: 'metric_histogram',
	MULTIPLE_CURRENCIES: 'multipleCurrencies',
	MULTIPLE_DASHBOARDS: 'multipleDashboards',
	MULTIPLE_ENTITIES: 'multipleEntities',
	MULTI_ACCOUNT_REPORTING: 'multiAccountReporting',
	MULTI_FACTOR_AUTHENTICATION: 'multiFactorAuthentication',
	NOTIFICATIONS: 'notifications',
	PAGE_OCCUPANCY_REPORT: 'pageOccupancyReport',
	PARTIAL_INVOICING: 'partialInvoicing',
	PIPELINE_REPORT: 'pipelineReport',
	PREPAYMENT_INVOICES: 'prepaymentInvoices',
	PRICE_LISTS: 'priceLists',
	PRODUCT_ADDONS: 'product_addons',
	PROJECTS_TIMELINE: 'projectsTimeline',
	PROJECT_ADDONS: 'project_addons',
	PROJECT_PHASES: 'projectPhases',
	PROJECT_TEMPLATES: 'projectTemplates',
	PROJECT_CHART_GROUP_BY_FAKE_DOOR: 'project_charts_group_by_fake_door',
	PROJECT_CHARTS: 'project_charts',
	PROJECT_HEALTH_ANALYZER: 'project_health_analyzer',
	QUICKBOOKS_SYNC: 'quickbook_sync',
	QUOTES_TEMPLATES: 'quotes_templates',
	QUOTE_STATUS_CHANGE_LOG: 'quoteStatusChangeLog',
	QUOTE_TO_TASKS: 'quoteToTasks',
	REAL_ESTATE_ADDONS: 'real_estate_addons',
	RECURRING_TASKS: 'recurring_tasks',
	RETAINERS: 'retainers',
	REVENUE_FORECAST: 'revenue_forecast',
	ROLES: 'roles',
	ROLES_AS_PROJECT_MEMBERS: 'roles_as_project_members',
	RULES_AND_ALERTS: 'rulesAndAlerts',
	SAGE: 'sage',
	SALES_ADDONS: 'sales_addons',
	SALES_REPORTS: 'salesReports',
	SCHEDULED_BILLS: 'scheduledBills',
	SCHEDULED_INVOICES: 'scheduledInvoices',
	SESSIONS_GARBAGE_COLLECTION: 'sessionsGarbageCollection',
	SINGLE_SIGN_ON: 'single_sign_on',
	SMART_INBOX: 'smart_inbox',
	STATUS_ADDONS: 'status_addons',
	SUBTASKS: 'subtasks',
	SUPPLIERS_LIST: 'suppliers_list',
	SYNCHRONIZER: 'synchronizer',
	TAG_GROUPS: 'tagGroups',
	TASK_BOARD: 'taskBoard',
	TASK_DEPENDENCIES: 'taskDependencies',
	TASK_MATRIX: 'taskMatrix',
	TASK_SETS: 'task_sets',
	TENTATIVE_BOOKINGS: 'tentative_bookings',
	TIMEOFF: 'timeoff',
	TIMESHEET: 'timesheet',
	TIME_TRACKER: 'timeTracker',
	TOGGL_SYNC: 'toggl_sync',
	TRIGGERS_ACTIONS: 'triggersActions',
	UNASSIGNED_TASKS: 'unassignedTasks',
	USERS_ON_SALES_DOCUMENTS_LINES: 'users_on_sales_documents_lines',
	UTILIZATION_REPORT: 'utilizationReport',
	WATCHDOG: 'watchdog',
	WEB_FORMS: 'webForms',
	WIP_REPORT: 'wipReport',
	WORK_SUMMARY_REPORT: 'workSummaryReport',
	XERO_SYNC: 'xero_sync',
	ZAPIER: 'zapier',
	BUDGETS: 'budgets',
	CUSTOM_EMAIL_DOMAIN: 'custom_email_domain',
	EXPORT_DATA: 'exportData',
} as const;
